<template lang="pug">
.card-coupons-box
  .card-coupons-container(
    v-if="info.type",
    :class="[ \
      'type-' + info.type, \
      'status-' + info.status, \
      info.disabled ? 'disabled' : '', \
      (info.assets && info.marketingWords && info.marketingWords.length>0) ? 'addHeight' : '', \
    ]",
    @click="click"
  )
    .corner.flex-mid(v-if="info.corner && info.type == CARD_COUPON_TYPE_NEW.TIME_COUPON")
      span {{ info.corner }}
    .left-container
      .left.column
        template(v-if="info.type == CARD_COUPON_TYPE_NEW.TIME_COUPON")
          .price(:class="['length-' + info.currentPriceV2[0].value.length]")
            span.current {{ info.currentPriceV2[0].value }}
            span.unit {{ info.currentPriceV2[0].unit }}
        template(v-else)
          img.img(:src="info.bizImg")
      .mid.column
        .title {{ info.title||'' }}
        .assets(v-if="info.assets") {{ info.assets }}
        .ticket(v-if="info.amount") 优惠券×
          span {{info.amount}}
        .cityTag(v-if="info.marketingWords&&info.marketingWords.length>0")
          span.city(v-for="word in info.marketingWords.slice(0, 2)") {{word.wordsValue}}
        template(v-if="info.type == CARD_COUPON_TYPE_NEW.TIME_COUPON")
          .subtitle {{ info.subtitle }}
        template(v-else)
          .subtitle
            .price-content.flex-mid(v-if="info.currentPriceV2[0] && info.originPrice")
              span.current-price
                span {{ info.currentPriceV2[0].value }}
                .unit {{ info.currentPriceV2[0].unit }}
              span.origin-price {{ info.originPrice }}
          .discount(v-if="!info.assets && !info.amount && !info.marketingWords")
            span 立省{{ discount }}元
        .process(v-if="info.percentage && info.type === 3")
          .line
            .colored(:style="{ width: info.percentage + '%' }")
          .status 已抢{{ info.status === TIME_COUPON_STATUS.NONE ? '100' : info.percentage }}%
    .right.column
      .btn.flex-mid(@click="$emit('btn', info)") {{ btn }}
        .btn-hand(v-if="info.status === TIME_COUPON_STATUS.GRAB&&!info.disabled&&!btnIndex")
          Lottie.lottie(:url="json")
      .direct-use.flex-mid(v-if="showDouble", @click="$emit('use', info)")
        span 直接用
        .common-arrow-right
</template>

<script>
import Lottie from '@/components/lottie';
import { MARKET_OFFER_TYPE } from '../../../const';
import { sub } from '../../../utils';
import { getFinalBuyPrice } from '../../card-for-app/utils';
import { CARD_COUPON_TYPE_NEW, TIME_COUPON_STATUS } from '../consts';

export default {
  components: {
    Lottie,
  },
  props: {
    info: {
      type: Object,
      // default: () => ({
      //   title: '单车骑行卡·30天不限次单车骑行卡·30天不限次',
      //   subtitle: '乘客确认到达可到账',
      //   originPrice: '20',
      //   diff: '平台补4.2元',
      //   type: CARD_COUPON_TYPE_NEW.TIME_COUPON,
      //   corner: '可膨胀',
      //   assets: '5元乘客券×4',
      //   percentage: '20',
      //   disabled: true,
      //   status: TIME_COUPON_STATUS.NONE,
      // }),
      default: null,
    },
    btnIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      TIME_COUPON_STATUS,
      CARD_COUPON_TYPE_NEW,
      MARKET_OFFER_TYPE,
      json: 'https://m.hellobike.com/resource/helloyun/18536/iqjqcdjXA6.json',
    };
  },
  computed: {
    showDouble() {
      return (
        this.info.type === CARD_COUPON_TYPE_NEW.TIME_COUPON
        && this.info.status === TIME_COUPON_STATUS.DOUBLE
      );
    },
    buyPrice() {
      return getFinalBuyPrice(this.info);
    },
    btn() {
      if (this.info.type === CARD_COUPON_TYPE_NEW.TIME_COUPON) {
        if (this.info.status === TIME_COUPON_STATUS.NONE) {
          return this.info.btn || '已抢完';
        }
        if (
          this.info.status === TIME_COUPON_STATUS.USE
          || this.info.status === TIME_COUPON_STATUS.GO_USE
        ) {
          return '去使用';
        }
        if (this.info.status === TIME_COUPON_STATUS.GRAB) {
          return '立即抢';
        }
        if (this.info.status === TIME_COUPON_STATUS.DOUBLE) {
          return '去膨胀';
        }
      }
      return this.info.btn || '购买';
    },
    discount() {
      if (this.info && this.info.originPrice) {
        const price = this.info.originPrice.match(/\d+/g)[0];
        return sub(price, this.info.currentPriceV2[0].value);
      }
      return '0';
    },
  },
  methods: {
    click() {
      this.$emit('click', this.info);
    },
  },
};
</script>

<style lang="less" scoped>
.mixin-btn-border() {
  width: 0.68rem;
  height: 0.25rem;
  border-radius: 0.13rem;
  border: 1px solid #ff6011;
  color: #ff5526;
  background: inherit;
}

.card-coupons-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
  border-radius: 0.08rem;
  box-sizing: border-box;
  background-size: 100% 100%;
  // padding-top: 0.2rem;
  // padding-bottom: 0.2rem;

  &.with-corner {
    padding-bottom: 0.17rem;
  }

  .column {
    height: 0.62rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .left {
    width: 0.56rem;
    margin-right: 0.1rem;

    .img {
      max-width: 0.56rem;
      max-height: 0.62rem;
    }
  }

  .mid {
    flex: 1;
    max-width: 1.65rem;
    align-items: flex-start;
    justify-content: space-between;
    white-space: nowrap;
    height: 100%;
  }

  .right {
    padding-right: 0.1rem;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .btn {
    width: 0.6rem;
    height: 0.25rem;
    line-height: 0.25rem;
    background: linear-gradient(270deg, #ff7e32 0%, #ff5100 100%);
    border-radius: 0.13rem;
    font-size: 0.12rem;
    font-weight: 500;
    color: #fff;
    margin-top: 0.06rem;
    position: relative;

    .btn-hand {
      width: 0.8rem;
      height: 0.8rem;
      position: absolute;
      left: 0.1rem;
      top: -0.1rem;
    }
  }

  .title {
    font-size: 0.14rem;
    font-weight: 500;
    min-height: 0.14rem;
    line-height: 0.14rem;
    color: #242729;
    max-width: 1.65rem;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: keep-all;
    word-wrap: normal;
    margin-bottom: 0.08rem;
    margin-top: -0.01rem;
  }

  .price {
    white-space: nowrap;

    > .unit {
      font-size: 0.12rem;
      font-weight: 600;
      color: #845529;
      margin-left: 2px;
      position: relative;
      bottom: 0.01rem;
    }
  }

  .assets {
    font-size: 0.12rem;
    color: #242729;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 1.65rem;
    margin-bottom: 0.08rem;
  }

  .subtitle {
    display: flex;
    font-size: 0.12rem;
    color: #5a6066;
    max-width: 1.65rem;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: keep-all;
    word-wrap: normal;
    padding-top: 0.01rem;
  }

  .discount {
    border-radius: 0.04rem;
    border: 0.01rem solid rgba(255, 85, 38, 0.6);
    padding: 0.02rem 0.04rem;
    color: #ff5526;
    line-height: 0.12rem;
    font-size: 0.12rem;
    margin-top: 0.05rem;
    max-height: 0.16rem;
  }

  .direct-use {
    display: flex;
    margin-top: 0.05rem;
    font-size: 0.12rem;
    font-weight: 600;
    color: #ff6940;

    .common-arrow-right {
      border-color: #ff6940;
      margin-left: -3px;
    }
  }

  .process {
    display: flex;
    align-items: center;
    margin-top: 0.05rem;

    .line {
      position: relative;
      width: 0.74rem;
      height: 0.05rem;
      border-radius: 0.025rem;
      background: #f6c9ac;
    }

    .colored {
      position: absolute;
      left: 0;
      top: 0;
      height: 0.05rem;
      background: linear-gradient(137deg, #ff8e67 0%, #ff5103 100%);
      border-radius: 0.025rem;
    }

    .status {
      margin-left: 0.05rem;
      font-size: 0.1rem;
      font-weight: 500;
      color: #242729;
    }
  }

  .price-content {
    align-items: baseline;

    .current-price {
      font-weight: 500;
      color: #ff5103;
      line-height: 0.16rem;
      font-size: 0.2rem;
      display: flex;
      align-items: baseline;

      .unit {
        position: relative;
        bottom: 0.01rem;
        margin: 0 0.04rem 0 0.01rem;
        font-size: 0.12rem;
      }
    }
  }

  .origin-price {
    color: #879099;
    text-decoration: line-through;
  }

  .current {
    font-size: 0.3rem;
    font-weight: bold;
    font-family: "DIN Alternate Bold", sans-serif;
    color: #ae5505;
    line-height: 1;
    letter-spacing: -1px;
    position: relative;
    top: 1px;
  }

  .corner {
    position: absolute;
    top: 0;
    left: 0;
    height: 0.15rem;
    background: #ec5e40;
    border-radius: 0.08rem 0 0.08rem 0;
    font-size: 10px;
    line-height: 1;
    padding: 0.01rem 0.06rem;
    color: rgba(255, 255, 255, 1);

    span {
      display: inline-block;
      transform: scale(1.1);
      transform-origin: center center;
    }
  }

  .left-container {
    display: flex;
    align-items: center;
    flex: 1;
    height: 100%;
  }

  &.type-2 {
    // height: 0.62rem;

    .title {
      max-width: 2rem;
      margin-bottom: 0.08rem;
    }

    .ticket {
      border-radius: 0.04rem;
      border: 0.01rem solid #99a1a8;
      padding: 0.02rem 0.04rem 0.01rem;
      font-weight: 400;
      color: #5a6066;
      line-height: 0.12rem;
      font-size: 0.12rem;
    }

    .right {
      padding-right: 0.12rem;
    }

    .price * {
      color: #b7712b !important;
    }

    .subtitle {
      margin-top: 0.08rem;
    }
  }

  &.type-3,
  &.type-4 {
    background-image: url(https://m.hellobike.com/resource/AppPlatformH5/fuli/vaD-vV1xfgZM2vdAdSQcJ.png);

    .corner {
      background: linear-gradient(137deg, #ff8e67 0%, #ff5103 100%);
    }

    .title {
      max-width: 1.5rem;
      margin-bottom: 0.06rem;
    }

    .btn {
      width: 0.68rem;
      height: 0.25rem;
      background: linear-gradient(270deg, #ff7e32 0%, #ff5100 100%);
      border-radius: 0.13rem;
      position: relative;

      .hint {
        position: absolute;
        background: #ff5103;
        color: white;
        top: -0.19rem;
        right: -0.24rem;
        border-radius: 0.04rem;

        span {
          display: inline-block;
          transform: scale(0.8);
          transform-origin: center center;
        }

        &::after {
          content: "";
          z-index: 3;
          display: inline-block;
          border-top: 0.03rem #ff5103 solid;
          border-left: 0.03rem transparent solid;
          border-right: 0.03rem transparent solid;
          position: absolute;
          left: 20%;
          bottom: -0.02rem;
        }
      }
    }

    .subtitle {
      max-width: 1.5rem;
      display: block;
    }
  }

  &.disabled {
    &.type-3 {
      .current,
      .unit,
      .title,
      .status {
        color: #879099 !important;
      }

      .line {
        background: #879099 !important;
        opacity: 0.6;
      }
    }
  }

  &.type-1 {
    height: 0.62rem;
    padding-top: 0;
    padding-bottom: 0;

    .left-container {
      .mid {
        justify-content: center;

        .title {
          max-width: 2rem;
          margin-bottom: 0.08rem;
        }

        .cityTag {
          padding-left: 0;
          display: flex;
          margin-bottom: 0.08rem;

          .city {
            padding: 0.02rem 0.04rem;
            background: #ecf7ff;
            font-size: 0.12rem;
            font-weight: 400;
            color: #08f;
            margin-right: 0.08rem;
            border-radius: 0.04rem;
            line-height: 0.12rem;
          }
        }
      }
    }

    .price {
      &.length-2 {
        .current {
          font-size: 0.3rem;
        }

        .unit {
          font-size: 0.12rem;
        }
      }

      &.length-3 {
        .current {
          font-size: 0.3rem;
        }

        .unit {
          font-size: 0.14rem;
        }
      }

      &.length-4 {
        .current {
          font-size: 0.28rem;
        }

        .unit {
          font-size: 0.12rem;
        }
      }

      &.length-5 {
        .current {
          font-size: 0.24rem;
        }

        .unit {
          font-size: 0.12rem;
        }
      }
    }
  }

  &.type-3 {
    background-image: url(https://m.hellobike.com/resource/helloyun/15979/cL6qzlyy4m.png);
    padding-top: 0.12rem;
    padding-bottom: 0.12rem;

    &.status-1 {
      .btn {
        background: #ffccbd;
      }
    }

    &.disabled {
      background-image: url(https://m.hellobike.com/resource/helloyun/15979/4TJ0wFdB5O.png);
      padding-bottom: 0.15rem;

      .corner {
        background: #bcc4cc;
      }

      .colored {
        background: linear-gradient(137deg, #acacac 0%, #838383 100%);
      }

      .right .btn {
        background: #bcc4cc;
        color: white;
        margin-top: 0;
      }
    }

    .left {
      width: 0.64rem;
      max-width: 0.64rem;
      overflow: hidden;
      text-overflow: ellipsis;

      .price {
        .current {
          font-size: 0.32rem;
          font-family: "DIN Alternate Bold", sans-serif;
          font-weight: bold;
          color: #ff5526;
        }

        .unit {
          font-size: 0.14rem;
          font-weight: 500;
          color: #ff5526;
          line-height: 0.14rem;
        }

        &.length-2 {
          .current {
            font-size: 0.28rem;
          }

          .unit {
            font-size: 0.12rem;
          }
        }

        &.length-3 {
          .current {
            font-size: 0.24rem;
          }

          .unit {
            font-size: 0.14rem;
          }
        }

        &.length-4 {
          .current {
            font-size: 0.2rem;
          }

          .unit {
            font-size: 0.12rem;
          }
        }
      }
    }

    &.status-2 {
      background-image: url(https://m.hellobike.com/resource/helloyun/15979/i5xOYsWdhy.png);

      .right .btn {
        width: 0.68rem;
        height: 0.24rem;
        border-radius: 0.13rem;
        color: #fff;
        background: linear-gradient(270deg, #ff984f 0%, #ff7e32 37%, #ff5100 100%);
      }
    }

    .subtitle {
      line-height: 0.14rem;
    }

    .column {
      max-height: 0.54rem;
    }
  }

  &.addHeight {
    height: 0.9rem !important;

    .left-container {
      .left {
        position: relative;
        top: -0.14rem;
      }
    }
  }
}
</style>
